// extracted by mini-css-extract-plugin
export default {"steps":"ProjectSteps_steps__SoiTX","step":"ProjectSteps_step__wyMt4"};